import React from 'react';
import './Service.css';

const Service = () => {
  const whatsappNumber = "254798503832"; 
  const whatsappMessage = "Hello! I need assistance with CBC resources and services.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const services = [
    {
      id: 1,
      title: "Academic Reports",
      description: "Professional report writing and analysis services for students, teachers, and educational institutions.",
      features: [
        "Progress reports and performance analysis",
        "Research summaries and literature reviews",
        "Educational assessment reports",
        "Custom report formatting and presentation"
      ],
      icon: "📊",
      color: "#3B82F6"
    },
    {
      id: 2,
      title: "Research Assistance",
      description: "Comprehensive research support for academic projects, curriculum development, and educational studies.",
      features: [
        "Research design and methodology guidance",
        "Data collection and analysis support",
        "Literature search and review assistance",
        "Academic writing and editing"
      ],
      icon: "🔍",
      color: "#10B981"
    },
    {
      id: 3,
      title: "Curriculum Analysis",
      description: "Detailed analysis of CBC curriculum alignment and effectiveness for educational planning.",
      features: [
        "Curriculum gap analysis",
        "Learning outcome assessments",
        "Resource effectiveness evaluation",
        "Implementation strategy planning"
      ],
      icon: "📚",
      color: "#8B5CF6"
    },
  ];

  const processSteps = [
    {
      step: 1,
      title: "Initial Consultation",
      description: "Discuss your specific needs and requirements through WhatsApp or email.",
      icon: "💬"
    },
    {
      step: 2,
      title: "Service Agreement",
      description: "We define the scope, timeline, and deliverables for your project.",
      icon: "📝"
    },
    {
      step: 3,
      title: "Service Delivery",
      description: "Our experts work on your project with regular updates and progress reports.",
      icon: "⚡"
    },
    {
      step: 4,
      title: "Review & Finalization",
      description: "You review the deliverables and we make any necessary revisions.",
      icon: "✅"
    }
  ];

  return (
    <div className="service-page">
      <div className="service-container">

        {/* Services Section */}
        <section className="services-section">
          <div className="section-header">
            <h2 className="section-title">What We Also Offer</h2>
            <p className="section-description">
              Comprehensive educational services designed to support students, teachers, and institutions
            </p>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-card">
                <div 
                  className="service-icon-wrapper"
                  style={{ backgroundColor: `${service.color}20`, borderColor: service.color }}
                >
                  <span className="service-icon">{service.icon}</span>
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <span className="feature-icon">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a 
                  href={whatsappLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="service-action-btn"
                  style={{ backgroundColor: service.color }}
                >
                  <span className="whatsapp-icon">💬</span>
                  Inquire via WhatsApp
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <div className="section-header">
            <h2 className="section-title">Our Process</h2>
            <p className="section-description">
              Simple, transparent process to ensure quality service delivery
            </p>
          </div>

          <div className="process-steps">
            {processSteps.map((step) => (
              <div key={step.step} className="process-step">
                <div className="step-number">{step.step}</div>
                <div className="step-icon">{step.icon}</div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="contact-container">
            <div className="contact-info">
              <h2 className="contact-title">Get Started Today</h2>
              <p className="contact-description">
                Ready to enhance your educational journey? Contact us to discuss how we can assist with 
                your reports, research, or curriculum needs.
              </p>
              
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-icon">📱</div>
                  <div className="method-details">
                    <h4>WhatsApp</h4>
                    <p>Fast, convenient communication for quick inquiries</p>
                    <a 
                      href={whatsappLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="whatsapp-btn"
                    >
                      <span className="btn-icon">💬</span>
                      Message on WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-note">
              <div className="note-icon">💡</div>
              <p className="note-text">
                <strong>Response Time:</strong> We typically respond to WhatsApp messages within 20 minutes 
                during business hours (8 AM - 6 PM EAT, Monday-Saturday).
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Service;